import React from 'react'
import { Radio } from 'atoms/Radio'
import translate from 'core/translate'
import { cn } from 'ethcss'
import styles from './deviceSettings__ignoreWebPageSecurity.jcss'
import { Typography } from 'atoms/Typography'
import { SwitchButton } from '../../../atoms/SwitchButton'

const IgnoreSettingsDisableWebPageSecurity = (p_: {
    enabled: boolean
    className: string | object
    value: boolean
    onChange: (value: any, field: string) => void
}) => {
    if (!p_.enabled) {
        return null
    }

    return (
        <div className={cn(p_.className)}>
            <div className={styles.switchWrapper}>
                <SwitchButton
                    checked={p_.value}
                    onChange={() => {
                        p_.onChange(!p_.value, 'ignoreWebPageSecurity')
                    }}
                    className={`test-settings-toggle_${p_.value ? 'enabled' : 'disabled'}`}
                />
                <div className={cn(styles.switchCaption)}>
                    <Typography className={cn(styles.title)} type="title">
                        {translate('ignoreWebPageSecurity')}
                    </Typography>
                </div>
            </div>
        </div>
    )
}

export default React.memo(IgnoreSettingsDisableWebPageSecurity)
